import React, { useEffect } from 'react'
import styled from '@emotion/native'
import { CONNECTION } from '~/const'
import { setGlobalState } from '~/store'
import { useGlobalState } from '~/store/hooks'
import { connect, disconnect, getConnection } from '~/server'
import { px } from '~/utils/device'

export default function InfoDev() {
    const [state] = useGlobalState((patch) => {
        // console.log('InfoDev', patch)
        return true
    })
    const color =
        state.connection === CONNECTION.CONNECTING
            ? '#CCCCCC'
            : state.connection === CONNECTION.OPEN
            ? '#00ff00'
            : '#ff0000'

    console.log('<InfoDev>', state.user)
    return (
        <InfoDevBackground>
            <InfoDevContainer color={color}>
                <InfoDevText>
                    {state.connection} readyState:
                    {getConnection().ws?.readyState}
                </InfoDevText>
                {/* <InfoPong state={state} /> */}
                <InfoDevText>{state.view}</InfoDevText>
                <InfoDevText>{state.login}</InfoDevText>
                <InfoDevText>
                    {state.email}:{state.token.slice(0, 5)}
                </InfoDevText>
                <InfoDevText></InfoDevText>
                <InfoDevText>
                    {state.user?.status?.type}.
                    {state.user?.status?.party?.status}
                </InfoDevText>
                <InfoDevText>game_id: {state.game_id}</InfoDevText>
                <InfoDevText>
                    sounds:{String(state.sounds)}-music:{String(state.music)}
                </InfoDevText>
                <InfoDevText>error: {JSON.stringify(state.error)}</InfoDevText>
                <InfoDevText>
                    rejection: {JSON.stringify(state.rejection)}
                </InfoDevText>
                <InfoMemory />
                <Buttons>
                    <Button
                        disabled={state.connection === CONNECTION.CONNECTING}
                        onPress={() => {
                            state.connection === CONNECTION.OPEN
                                ? disconnect()
                                : connect()
                        }}
                    >
                        <InfoDevText
                            color={
                                state.connection === CONNECTION.CONNECTING
                                    ? 'grey'
                                    : state.connection === CONNECTION.OPEN
                                    ? 'red'
                                    : 'green'
                            }
                            shadow="0 0 0"
                        >
                            {state.connection === CONNECTION.CONNECTING
                                ? 'connecting...'
                                : state.connection === CONNECTION.OPEN
                                ? 'disconnect'
                                : 'connect'}
                        </InfoDevText>
                    </Button>

                    {/* <Button onPress={connect}>
                        <InfoDevText>connect</InfoDevText>
                    </Button>
                    <Button onPress={disconnect}>
                        <InfoDevText>disconnect</InfoDevText>
                    </Button> */}
                </Buttons>
            </InfoDevContainer>
        </InfoDevBackground>
    )
}

function InfoPong({ state }) {
    const [lastpong, setLastpong] = React.useState(0)

    useEffect(() => {
        const interval = setInterval(() => {
            setLastpong((Date.now() - state.pong) / 1000)
        }, 1000)
    }, [])

    return <InfoDevText>pong: {lastpong}s</InfoDevText>
}

function InfoMemory() {
    const [memory, setMemory] = React.useState('')

    useEffect(() => {
        if (performance.memory) {
            const interval = setInterval(() => {
                const memoryUsage = performance.memory
                setMemory(
                    `${Math.round(memoryUsage.usedJSHeapSize / 1024 / 1024)} MB`
                )
            }, 1000)
        }
    }, [])

    return <InfoDevText>{memory}</InfoDevText>
}

const InfoDevBackground = styled.View`
    z-index: 9999;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    pointer-events: none;
    align-items: center;
    // justify-content: center;
`

const InfoDevContainer = styled.View`
    max-width: 100%;
    min-width: ${px(500)};
    border: ${px(5)} solid ${(p) => p.color};
    padding: ${px(20)};
    background: ${(p) => p.color}99;
`

const InfoDevText = styled.Text`
    font-size: ${px(30)};
    font-family: monospace;
    font-weight: bold;
    color: ${(p) => p.color || 'black'};
    // text-shadow: ${(p) => p.shadow || '0px 0px 1px white'};
`

const Buttons = styled.View`
    width: 100%;
    height: ${px(60)};
    flex-direction: row;
`

const Button = styled.TouchableOpacity`
    flex: 1;
    background: grey;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    background: #ccc;
    pointer-events: auto;
`

// nonExistentFunction()
window.addEventListener('error', (e) => {
    const errorMessage =
        typeof e.message === 'string' ? e.message : JSON.stringify(e.message)
    setGlobalState({ error: errorMessage })
    // const error = JSON.stringify({
    //     message: e.message,
    //     filename: e.filename,
    //     lineno: e.lineno,
    //     colno: e.colno,
    //     // stack: e.error.stack,
    // })
    // console.log(error)
})

// Promise.reject(new Error('This is a test unhandled rejection'));
window.addEventListener('unhandledrejection', (e) => {
    setGlobalState({ rejection: e.reason.message || e.reason.error || e.error })
})
